// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"493":"backoffice","842":"map"}[chunkId] + "." + {"493":"524e0cc9","842":"fc63d424"}[chunkId] + ".css";
};